import { ArrowUpRight, CalendarDays, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

export const Retreat = () => (
  <section id="events" data-testid="events-section" className="bg-ink py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal>
        <p className="eyebrow text-gold">Upcoming Events</p>
      </Reveal>
      <Reveal delay={0.08}>
        <div className="mt-10 grid md:grid-cols-2 gap-10 md:gap-16 items-center border border-gold/30 p-6 md:p-12" data-testid="retreat-card">
          <div className="relative">
            <div className="absolute inset-0 translate-x-3 translate-y-3 border border-gold/60" aria-hidden="true" />
            <img src="/photos/return-to-innocence-retreat.jpg" alt="Return to Innocence Retreat — Springbrook rainforest"
              data-testid="retreat-image" className="relative w-full aspect-[4/3] object-cover" />
          </div>
          <div>
            <p className="eyebrow text-cream/60">Retreat · Womyn only</p>
            <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl text-cream mt-4 leading-tight">
              Return to <span className="italic text-gold">Innocence</span> Retreat
            </h2>
            <p className="mt-5 text-cream/70 text-sm md:text-base leading-relaxed" data-testid="retreat-description">
              A serene, peaceful, restorative womyn-only retreat designed to nurture rest,
              connection, healing, creativity, reflection and renewal.
            </p>
            <div className="mt-6 space-y-2.5 text-sm text-cream/70">
              <p className="flex items-center gap-3" data-testid="retreat-date">
                <CalendarDays size={15} className="text-gold shrink-0" /> 27 November 2026
              </p>
              <p className="flex items-center gap-3" data-testid="retreat-location">
                <MapPin size={15} className="text-gold shrink-0" /> Springbrook Rainforest Retreat, Springbrook QLD
              </p>
            </div>
            <a href="https://www.eventbrite.com.au/e/return-to-innocence-retreat-tickets-2001762945857"
              target="_blank" rel="noopener noreferrer" data-testid="retreat-tickets-link"
              className="mt-8 inline-flex items-center gap-2 eyebrow bg-gold text-ink px-6 py-3.5 rounded-full hover:bg-cream transition-colors duration-300">
              Tickets via Eventbrite <ArrowUpRight size={14} />
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
